import { CommnetComponentsType } from "types/main";
import VirtualProfile from "./VirtualProfile";
import { TAILWIND_TO_CSS } from "utils/constant/STYLE";

function DebateUserProfile({
  data,
  type,
}: {
  type: CommnetComponentsType;
  data?: any;
}) {
  if (type === "opinion") {
    return (
      <div className="flex flex-col py-2 gap-2 h-full ">
        <VirtualProfile data={data} isMyComment={false} />
        <div className="flex flex-col grow h-full items-center">
          <div className="h-full w-[1px] bg-gray15"></div>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M12.5 -5.02683e-07L12.5 0.499999C12.5 6.85127 17.6487 12 24 12V12"
                stroke={TAILWIND_TO_CSS["gray15"]}
              />
            </svg>
          </div>
        </div>
      </div>
    );
  } else if (type === "comment") {
    return (
      <div className="flex flex-col py-2 gap-2 h-full ">
        <VirtualProfile data={data} isMyComment={false} />
        <div className="flex flex-col grow h-full items-center">
          <div className="h-full w-[1px] bg-gray15"></div>
        </div>
      </div>
    );
  } else return null;
}

export default DebateUserProfile;
